import colors from "./colors";
import { breakpoints, maxBreakpoints } from "./breakpoints";

const theme = {
  fontWeights: {
    normal: 400,
  },
  fontSizes: {
    small: "18px",
    normal: "20px",
    large: "24px",
    headline: "64px",
    title: "42px",
    subtitle: "34px",
  },
  spacing: {
    x1: "8px",
    x2: "16px",
    x3: "24px",
    x4: "32px",
    x5: "40px",
    x8: "64px",
    x10: "80px",
    x12: "96px",
  },
  radii: {
    x1: "8px",
    x2: "16px",
    x3: "24px",
    x4: "32px",
    x8: "64px",
    x10: "80px",
  },
  colors,
  sizes: {
    navbarHeight: "80px",
  },
  breakpoints,
  maxBreakpoints,
};

export default theme;
